import BarChart from './BarChart';
import './BarChart.scss';

export default BarChart;